import { Container } from "@mantine/core"
import { DataFetchWrapper } from "@tfg/ui"

import { FAQContent } from "~/pages/Brand/FAQ/FAQContent.tsx"
import { useFAQQuery } from "~/pages/Brand/FAQ/hooks.ts"

export const FAQ = () => {
  const faqQuery = useFAQQuery()

  return (
    <Container fluid py="xl" px="lg">
      <DataFetchWrapper query={faqQuery}>
        {({ data }) => <FAQContent faqs={data} />}
      </DataFetchWrapper>
    </Container>
  )
}
